import React, { Component } from "react";
import { PageHeader } from "react-bootstrap";
import { Row, Col, Button, FormGroup, Tabs, Tab, FormControl, Table, Modal, Label, Glyphicon, ControlLabel, Image } from "react-bootstrap";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {ToastContainer, ToastStore} from 'react-toasts';

import UsersService from "../../services/users-service";
import FormdataService from "../../services/formdata-service";
import IncidentsService from '../../services/incidents-service';
import UtilsService from '../../services/utils-service';
import './style.css';

import Widgets from "../../components/widgets";
import EventWidget from "../../components/widgets/event-widget";
import AddIncident from "../../components/incidents-add-incident";
import LiveNationAddIncident from "../../components/live-nation-add-incident";
import EmployeeAddIncident from "../../components/incident-employee";

import IncidentArchive from "../../components/incidents-archive";
import AlertModal from "../../components/alert-modal";
import moment from 'moment';

//For Massive Forms. Has better control over text and stuff supposedly.
var pdfMake = require('pdfmake/build/pdfmake.js');
var vfs_fonts = require('pdfmake/build/vfs_fonts.js');
pdfMake.vfs = vfs_fonts.pdfMake.vfs;

class Incident extends Component {

    tableData = {
        rows: []
    }

    constructor(props, context) {
        super(props, context);

        this.state = {
            show: false,
            data: null,
            storedCredentials: UsersService.sharedInstance.getStoredCredentials(),
            showLinkIncidentsModal: false,
            incident_types: [],
            incidents: [],
            facilities: [],
            facility_locations: [],
            auto_emails: [],
            eventKey: 1,
            onEditMode: false,
            itemToEdit: null,
            onDeleteMode: false,
            liveNationIncidentType: null, //If Guest or Employee
        }

        this.archiveChild = React.createRef();
        this.editTabRendered = false;
        this.fetchIncidents = this.fetchIncidents.bind(this);

        this.timer = null;
        this.handleSelect = this.handleSelect.bind(this);
        this.handleEditIncident = this.handleEditIncident.bind(this);
        this.deleteIncidents = this.deleteIncidents.bind(this);
        this.linkIncidents = this.linkIncidents.bind(this);
        this.editTabTitle = this.editTabTitle.bind(this);
        this.showConfirmationModal = this.showConfirmationModal.bind(this);
        this.handleContinueButton = this.handleContinueButton.bind(this);
        this.handleExitButton = this.handleExitButton.bind(this);

        this.prepLiveNationPDFDocDefinition = this.prepLiveNationPDFDocDefinition.bind(this);
        this.prepLiveNationPDFDocDefinitionEmployee = this.prepLiveNationPDFDocDefinitionEmployee.bind(this);
        this.stringArrayToString = this.stringArrayToString.bind(this);
        this.makePDFBlob = this.makePDFBlob.bind(this);
        this.setShowLinkIncidentsModal = this.setShowLinkIncidentsModal.bind(this);
        this.setShowMergeModal = this.setShowMergeModal.bind(this);
        this.setDownloadPDF = this.setDownloadPDF.bind(this);
        this.setCountSelectedIncidents = this.setCountSelectedIncidents.bind(this);

    }

    componentWillMount() {
        this.getFormDataByType("Incident_Type");
        this.getFormDataByType("Facility");
        this.getFormDataByType("Facility_Location");
        this.getFormDataByType("Auto_Email");

        this.fetchIncidents();
      }

    render(){
        //console.log('rendering incident tabs for key', this.state.eventKey);
        return(
                <div classID="incident-page">
                    <Row className="widget-top-container">
                      <Col md={5} style={{backgroundColor: "white"}}>
                        <EventWidget events={this.props.events}/>
                      </Col>
                    </Row>
                    <Row className="main-settings-content">
                        <Col>
                            <div className="settings-header">
                                <h2 className="header-title left-header">Incidents</h2>
                                {this.renderArchiveButtons()}
                            </div>
                            <div className="tab-container">
                                <Tabs defaultActiveKey={this.state.eventKey} id="incidents-tabs" activeKey={this.state.eventKey} onSelect={(activeKey)=> this.handleSelect(activeKey)}>
                                    <Tab eventKey={1} title="New Incident" className="leftmost-tab incident-tab" onSelect={()=>this.handleSelect(1)}>
                                        {this.renderIncidentTabs()}
                                    </Tab>
                                    <Tab eventKey={2} title="Archives" className="incident-tab">
                                        <IncidentArchive ref={this.archiveChild}
                                                    editMode={this.handleEditIncident}
                                                    tableData={this.state.data}
                                                    incidents={this.state.incidents}
                                                    incidentTypes={this.props.incidentTypes}
                                                    facilities={this.props.facilities}
                                                    events={this.props.events}
                                                    getNameForRecno={this.props.getNameForRecno}
                                                    prepLiveNationPDFDocDefinition={this.prepLiveNationPDFDocDefinition}
                                                    prepLiveNationPDFDocDefinitionEmployee={this.prepLiveNationPDFDocDefinitionEmployee}
                                                    stringArrayToString={this.stringArrayToString}
                                                    fetchIncidents={this.fetchIncidents}
                                                    // showLinkIncidentsModal={this.state.showLinkIncidentsModal}
                                                    // setShowLinkIncidentsModal={this.setShowLinkIncidentsModal}
                                                    showMergeModal={this.state.showMergeModal}
                                                    setShowMergeModal={this.setShowMergeModal}
                                                    incidentType={this.props.incidentType}
                                                    setDownloadPDF={this.setDownloadPDF}
                                                    setCountSelectedIncidents={this.setCountSelectedIncidents}/>
                                    </Tab>
                                    { this.renderEditTab() }
                                    { this.handleChangeTabEdit() }
                                </Tabs>
                            </div>
                        </Col>
                    </Row>
                    <AlertModal message="You're leaving without completely entering incident information." isShowing={this.state.showWarningModal} cancelButton={this.handleExitButton} continueButton={this.handleContinueButton}/>
                     <Image id={"liveNationLogo"} src={require('../../assets/liveNationIcon.png')} style={{display:"none"}} />
                </div>
        )
    }

    renderLiveNationIncidentIntro() {
        return (<Row className="pull-center">
                  <Col md={12} className="pull-center offset-md-4" style={{marginTop: "10%", justifyContent: "center"}}>
                    <Row style={{marginBottom: 50}}><Button style={{width: 180}} className="green-btn" onClick={()=>{this.setState({liveNationIncidentType: "guest"})}}>Guest</Button></Row>
                    <Row><Button style={{width: 180}} className="green-btn" onClick={()=>{this.setState({liveNationIncidentType: "employee"})}}>Employee</Button></Row>
                  </Col>
                </Row>);
    }

    renderIncidentTabs(){
        {/* this is already working */}
        if(this.props.incidentType == "live_nation"){
        //if(true) {

          switch(this.state.liveNationIncidentType) {
            case "guest":
              return (<LiveNationAddIncident
                          incident_types={this.state.incident_types}
                          tableData={this.state.data}
                          incidents={this.state.incidents}
                          facilities={this.state.facilities}
                          facility_locations={this.state.facility_locations}
                          events={this.props.events}
                          auto_emails={this.state.auto_emails}
                          changeTab={this.handleChangeTab}
                          fetchIncidents={this.fetchIncidents}
                          prepLiveNationPDFDocDefinition={this.prepLiveNationPDFDocDefinition}
                          makePDFBlob={this.makePDFBlob}/>
              )
            case "employee":
              return <EmployeeAddIncident
                        incident_types={this.state.incident_types}
                        tableData={this.state.data}
                        incidents={this.state.incidents}
                        facilities={this.state.facilities}
                        facility_locations={this.state.facility_locations}
                        events={this.props.events}
                        auto_emails={this.state.auto_emails}
                        changeTab={this.handleChangeTab}
                        fetchIncidents={this.fetchIncidents}
                        prepLiveNationPDFDocDefinitionEmployee={this.prepLiveNationPDFDocDefinitionEmployee}
                        makePDFBlob={this.makePDFBlob}/>
            default:

            return (this.renderLiveNationIncidentIntro())
          }

        }
        else {
            return (
                <AddIncident
                    tableData={this.state.data}
                    incident_types={this.state.incident_types}
                    facilities={this.state.facilities}
                    facility_locations={this.state.facility_locations}
                    auto_emails={this.state.auto_emails}
                    changeTab={this.handleChangeTab}
                    incidents={this.state.incidents}
                    facilities={this.state.facilities}
                    facility_locations={this.state.facility_locations}
                    events={this.props.events}
                    auto_emails={this.state.auto_emails}
                    fetchIncidents={this.fetchIncidents}
                />
            )
        }
    }

    renderArchiveButtons(){
        //console.log('rendering archive button', this.state.eventKey);
        if (this.state.eventKey == 2){
            return (
                <div className="header-controls">
                        <Button id="merge-btn" className="green-btn" onClick={() => this.state.downloadPDF(true)}>Download</Button>
                        <Button id="merge-btn"className="green-btn" onClick={() => {this.mergeIncidents()}}>Merge Incidents</Button>
                        <Button id="link-btn" className="blue-btn" onClick={() => {this.linkIncidents()}}>Link Incidents</Button>
                        <Button id="link-btn" className="red-btn" onClick={this.deleteIncidents}>Delete</Button>
                </div>
            )
        }
        else {
            return (null);
        }
    }

    handleSelect(eventKey){
        //console.log('current event key', eventKey, " this.state.eventKey: ", this.state.eventKey);
        // let mode = eventKey != 5 ? false : true;
        this.setState({eventKey: eventKey, liveNationIncidentType: eventKey != this.state.eventKey ? null : this.state.liveNationIncidentType});
    }

    handleChangeTab(){
        document.getElementById('incidents-tabs-tab-2').click();

    }

    showConfirmationModal(){
        this.setState({showWarningModal: true});
    }

    renderEditTab() {
        if (this.state.onEditMode == true){


            //console.log('edit tab rendered this.props.incidentType: ', this.props.incidentType);
            var toRender = <AddIncident
                                incident_types={this.state.incident_types}
                                facilities={this.state.facilities}
                                facility_locations={this.state.facility_locations}
                                auto_emails={this.state.auto_emails}
                                changeTab={this.handleExitButton}
                                itemToEdit={this.state.itemToEdit}
                                fetchIncidents={this.fetchIncidents}
                            />;
              var other_form_data = {};

              if(this.state.itemToEdit && this.state.itemToEdit.other_form_data) {
                other_form_data = UtilsService.sharedInstance.tryParseJSON(this.state.itemToEdit.other_form_data) ? JSON.parse(this.state.itemToEdit.other_form_data) : {};
              }

              if(this.props.incidentType === "live_nation") {
                if(other_form_data.employee_form) {
                  toRender = <EmployeeAddIncident
                                incident_types={this.state.incident_types}
                                tableData={this.state.data}
                                incidents={this.state.incidents}
                                facilities={this.state.facilities}
                                facility_locations={this.state.facility_locations}
                                events={this.props.events}
                                auto_emails={this.state.auto_emails}
                                changeTab={this.handleExitButton}
                                fetchIncidents={this.fetchIncidents}
                                itemToEdit={this.state.itemToEdit}
                                getRecnoForName={this.props.getRecnoForName}
                            />;
                } else {
                  toRender = <LiveNationAddIncident
                                incident_types={this.state.incident_types}
                                tableData={this.state.data}
                                incidents={this.state.incidents}
                                facilities={this.state.facilities}
                                facility_locations={this.state.facility_locations}
                                events={this.props.events}
                                auto_emails={this.state.auto_emails}
                                changeTab={this.handleExitButton}
                                fetchIncidents={this.fetchIncidents}
                                itemToEdit={this.state.itemToEdit}
                                getRecnoForName={this.props.getRecnoForName}
                            />;
                }
              } else {
                toRender = <AddIncident
                              incident_types={this.state.incident_types}
                              facilities={this.state.facilities}
                              facility_locations={this.state.facility_locations}
                              auto_emails={this.state.auto_emails}
                              changeTab={this.handleExitButton}
                              itemToEdit={this.state.itemToEdit}
                              tableData={this.state.data}
                              fetchIncidents={this.fetchIncidents}
                          />;
              }

              return (
                  <Tab eventKey={5}
                      title={this.editTabTitle()}
                      className="incident-tab" onSelect={()=>this.handleSelect(5)}>
                      {toRender}
                  </Tab>
              )

        }
    }

    editTabTitle(){
        return (
            <div>{"Edit Incident"}
                <Glyphicon
                    glyph="remove" className="pull-right"
                    style={{cursor: "pointer", marginLeft: 15}}
                    onClick={(e)=>{
                        e.stopPropagation();
                        this.showConfirmationModal();
                    }}/>
            </div>
        )
    }

    handleChangeTabEdit(){
        // if (this.state.onEditMode == true && this.editTabRendered == false){
        //     this.timer = setTimeout(() => {
        //         this.editTabRendered = true;
        //         console.log('switch to edit tab');
        //         document.getElementById('incidents-tabs-tab-5').click();
        //         this.stopTimer();
        //     }, 1000)
        // }
    }

    stopTimer(){
        //console.log('clear timer');
        clearTimeout(this.timer);
    }

    handleEditIncident(itemToEdit){
        this.setState({onEditMode: true, itemToEdit: itemToEdit, eventKey: 5});
    }

    setShowLinkIncidentsModal(set){
      this.setState({
        showLinkIncidentsModal: set,
      })
    }

    mergeIncidents() {
      //console.log("mergeIncidents");

      if(this.state.countSelectedIncidents() > 0) {
        this.setState({
          showMergeModal: true,
        })
      } else {
        ToastStore.error("No Incidents selected!");
      }

    }

    setShowMergeModal(set) {
      this.setState({
        showMergeModal: set,
      })
    }

    linkIncidents(){
      //console.log('about to link');
      this.archiveChild.current.onLinkIncidents();
    }

    deleteIncidents(){
        //console.log('about to delete');
        this.archiveChild.current.onDeleteItem();
    }

    getFormDataByType(dropDownName){ //index used in then() block
        var type = dropDownName.replace(" ", "_");

        const storedCredentials = this.state.storedCredentials;
        const loginResponse = storedCredentials.loginResponse;

        var params = {
            "license":loginResponse.data[0].User_License,
            "auth_username":loginResponse.data[0].User_ID,
            "token":loginResponse.token_data.token,
            "type":type
        };


        FormdataService.sharedInstance.getFormDataByType(params)
        .then((response)=>{
            if(type == "Incident_Type"){
                this.setState({
                    incident_types: response
                });
            }
            else if(type == "Facility"){
                this.setState({
                    facilities: response
                });
            }
            else if(type == "Facility_Location"){
                this.setState({
                    facility_locations: response
                });
            }
            else if (type == "Auto_Email"){
                this.setState({
                    auto_emails: response
                })
            }
        })
        .catch((error)=>{
            console.log("getFormDataByType error: ", error);
        });
    }

    handleExitButton(){
        this.handleChangeTab();
        this.editTabRendered = false;
        this.setState({eventKey: 2, showWarningModal: false, onEditMode: false});
    }

    handleContinueButton(){
        this.setState({showWarningModal: false});
    }

    fetchIncidents(startDate, endDate) {

        let params = {
            "license": this.state.storedCredentials.license,
            "token": this.state.storedCredentials.token,
            "auth_username": this.state.storedCredentials.username,
            "start_date": startDate ? moment(startDate).format("YYYY-MM-DD") : null,
            "end_date": endDate ? moment(endDate).format("YYYY-MM-DD") : null,
        }

        //console.log("params", params);

        IncidentsService.sharedInstance.getAll(params)
        .then((response)=>{

            this.tableData.rows = [];

            //console.log('fetch incidents response', response);

            response.map((item)=>{
                let json_data = [];
                let title = "";
                try{
                    json_data = JSON.parse(item.individuals_data);
                    // console.log('json data', json_data);
                    title = UsersService.sharedInstance.returnEmptyIfNull(json_data[0].name);
                }
                catch(e){
                    title = "Custom Incident Form - Live Nation";
                }

                let incidentType = UsersService.sharedInstance.returnEmptyIfNull(item.incident_type);

                if(item.incident_form_type == "live_nation"){
                    //check the incident type in the other form data
                    let otherFormData = "";
                    let liveNationIncdentTypes = "";

                    try{
                        otherFormData = JSON.parse(item.other_form_data);
                        liveNationIncdentTypes = otherFormData.incident_type;
                        incidentType = liveNationIncdentTypes.join();
                    }
                    catch(e){
                        incidentType = "";
                    }

                    if(incidentType == ""){
                        try{
                            //check if employee form
                            otherFormData = JSON.parse(item.other_form_data);
                            let employeeForm = otherFormData.employee_form == true || otherFormData.employee_form == 1 ? "Employee" : "";
                            incidentType = employeeForm;
                        }
                        catch(e){
                            incidentType = "";
                        }
                    }
                }

                var item_data = {
                    "id": UsersService.sharedInstance.returnEmptyIfNull(item.id),
                    "title": title,
                    "type": incidentType,
                    "facility": UsersService.sharedInstance.returnEmptyIfNull(item.facility_name),
                    "time": UsersService.sharedInstance.returnEmptyIfNull(item.date_added),
                    "staff": UsersService.sharedInstance.returnEmptyIfNull(item.first_name + ' ' + item.last_name),
                    "status": UsersService.sharedInstance.returnEmptyIfNull(item.status),
                    "event": UsersService.sharedInstance.returnEmptyIfNull(item.event_name),
                    "location": UsersService.sharedInstance.returnEmptyIfNull(item.location_name),
                }

                this.tableData.rows.push(item_data);
            });

            this.setState({data: this.tableData, incidents: response});
        });
    }

    prepLiveNationPDFDocDefinition(selectedItem) {

      var styles = {
        title: {
          fontSize: 10,
          bold: true,
          alignment: 'center',
        },
        header: {
          fontSize: 11,
          alignment: 'center',
          color: '#785448'
        },
        normal: {
          fontSize: 9,
        },
        normalBold: {
          fontSize: 9,
          bold: true,
        },
        normalIndented: {
          fontSize: 10,
          leadingIndent: 15,
          color: '#785448'
        },
        normalCenteredBold: {
          fontSize: 10,
          alignment: 'center',
          bold: true,
          color: '#785448'
        },
        normalBoldAlignLeft: {
          fontSize: 10,
          alignment: 'left',
          bold: true,
        }
      };

      if(typeof(selectedItem) == "undefined"){
          selectedItem = {};
      }

      var other_form_data = UtilsService.sharedInstance.tryParseJSON(selectedItem.other_form_data) ? JSON.parse(selectedItem.other_form_data) : {};

      let emptyWitnesses = [{"name":"","phone":"","relationship":"","description":""}, {"name":"","phone":"","relationship":"","description":""}];
      let emptyStaffWitnesses = [{"description":""},{"description":""}];

      //initialize these data to avoid error in PDF download
      var witnesses = other_form_data.witnesses ? other_form_data.witnesses : emptyWitnesses;
      var staffWitnesses = other_form_data.staffWitnesses ? other_form_data.staffWitnesses : emptyStaffWitnesses;

      //check if witnesses are valid
      if(typeof(witnesses[0]) == "undefined"){
          witnesses = emptyWitnesses;
      }

      //check if staffWitnesses are valid
      if(typeof(staffWitnesses[0]) == "undefined"){
          staffWitnesses = emptyStaffWitnesses;
      }


     var content =  [
                    {columns: [
                     {width: 200, text: [{text: "Venue Name: ",
                                            style: ['normal', {bold: true}]},
                                          {text: selectedItem.facility_name != null ? selectedItem.facility_name : "---", style: ['normal']},
                                        ], lineHeight: 1.5, },
                     {width: 200, text: [{text: "Address: ",
                                            style: ['normal', {bold: true}]},
                                          {text: other_form_data.address ? other_form_data.address : this.createUnderline(30), style: ['normal']},
                                        ], lineHeight: 1.5, },
                      {width: 200, text: [{text: "Date: ",
                                             style: ['normal', {bold: true}]},
                                           {text: selectedItem.date_added ? moment(selectedItem.date_added).format("MM-DD-YYYY h:mm A") : this.createUnderline(40), style: ['normal']},
                                         ], lineHeight: 1.5, }]},
                     {columns: [
                                     {width: 400, text: [{text: "Incident Involves: ",
                                                            style: ['normal', {bold: true}]},
                                                          {text: other_form_data.incident_involved ? this.stringArrayToString(other_form_data.incident_involved) : this.createUnderline(60) , style: 'normal'},
                                                        ], lineHeight: 1.5, },
                                     {width: 150, text: [{text: "Tape on File: ",
                                                            style: ['normal', {bold: true}]},
                                                          {text: selectedItem.tape_on_file ? "Yes" : "No", style: ['normal']},
                                                        ], lineHeight: 1.5, }]},
                      {columns: [
                                      {width: 120, text: [{text: "Incident Date:    ",
                                                             style: ['normal', {bold: true}]},
                                                           {text: selectedItem.date_added ? moment(selectedItem.date_added).format("MM-DD-YYYY") : this.createUnderline(40), style: ['normal']},
                                                         ], lineHeight: 1.5, },
                                      {width: 450, text: [{text: "Headlining Band or Event Name: ",
                                                             style: ['normal', {bold: true}]},
                                                           {text: selectedItem.event_name ? selectedItem.event_name : this.createUnderline(60), style: ['normal']},
                                                         ], lineHeight: 1.5, }]},
                     {columns: [
                                     {width: 130, text: [{text: "Time of Incident:  ",
                                                            style: ['normal', {bold: true}]},
                                                          {text: other_form_data.time_of_incident ? other_form_data.time_of_incident : this.createUnderline(10), style: ['normal']},
                                                        ], lineHeight: 1.5, },
                                     {width: 150, text: [{text: "Time Security Arrived:  ",
                                                             style: ['normal', {bold: true}]},
                                                           {text: other_form_data.time_security_arrived ? other_form_data.time_security_arrived : this.createUnderline(10), style: ['normal']},
                                                         ], lineHeight: 1.5, },
                                     {width: 180, text: [{text: "Time Emergency/Police Arrived:  ",
                                                              style: ['normal', {bold: true}]},
                                                            {text: other_form_data.time_police_arrived ? other_form_data.time_police_arrived : this.createUnderline(10), style: ['normal']},
                                                          ], lineHeight: 1.5, }]},
                    {lineHeight: 1.5, text: " ", style: 'normal'},
                    {canvas: [{ type: 'line', x1: 0, y1: 5, x2: 595-2*40, y2: 5, lineWidth: 1 }]},
                    {lineHeight: 1.5, text: "QUESTIONS TO ASK GUEST: ", style: ['normalBoldAlignLeft', {color: 'red'}]},
                    {lineHeight: 1.5, text: " ", style: 'normal'},

                    this.renderGuests(selectedItem, other_form_data),

                    {pageBreak: 'before', columns: [
                      {width: 300, text: [{text: "Venue Name: ",
                                             style: ['normal', {bold: true}]},
                                           {text: selectedItem.facility_name != null ? selectedItem.facility_name : "---", style: ['normal', {decoration: "underline"}]},
                                         ], lineHeight: 1.5, },
                      {width: 200, text: [{text: "Date: ",
                                             style: ['normal', {bold: true}]},
                                           {text: moment(selectedItem.date_added).format("MM-DD-YYYY h:mm A"), style: ['normal', {decoration: "underline"}]},
                                         ], lineHeight: 1.5, }]},
                   {lineHeight: 1.5, text: " ", style: 'normal'},
                   {canvas: [{ type: 'line', x1: 0, y1: 5, x2: 595-2*40, y2: 5, lineWidth: 1 }]},
                    {lineHeight: 1.5, text: "MEDICAL: ", style: ['normalBoldAlignLeft', {color: 'red'}]},
                    {lineHeight: 1.5, text: " ", style: 'normal'},
                    {lineHeight: 1.5, text: [{text: "Venue First Aid (ice pack, band-aid, etc.):    ", style: 'normalBold'}, {text: selectedItem.first_aid_accepted != null
                                                                                                                                             ? selectedItem.first_aid_accepted
                                                                                                                                                ? "Accepted"
                                                                                                                                                : "Declined"
                                                                                                                                              : "---", style: 'normal'}]},
                    {columns: [
                      {width: 200, lineHeight: 1.5, text: [{text: "Paramedics Called:    ",
                                             style: ['normal', {bold: true}]},
                                           {text: selectedItem.paramedics_called != null
                                                        ? selectedItem.paramedics_called
                                                          ? "Yes"
                                                          : "No"
                                                        : "---", style: 'normal'},
                                         ]},
                      {width: 300, lineHeight: 1.5, text: [{text: "Offsite Emergency Care:    ",
                                             style: ['normal', {bold: true}]},
                                           {text: other_form_data.offsite_emergency_care != null
                                                        ? this.stringArrayToString(other_form_data.offsite_emergency_care)
                                                        : "---", style: 'normal'},
                                         ]}]},
                   {lineHeight: 1.5, text: [{text: "If treated offsite, transported by:    ", style: 'normalBold'},
                            {text: selectedItem.transportation_explanation
                                          ? selectedItem.transportation_explanation
                                          : selectedItem.transported_by, style: 'normal'}]},
                   {canvas: [{ type: 'line', x1: 0, y1: 5, x2: 595-2*40, y2: 5, lineWidth: 1 }]},
                   {lineHeight: 1.5, text: " ", style: 'normalBold'},
                   {lineHeight: 1.5, text: [{text: "Transported to (medical facility):     ", style: 'normalBold'}, {text: selectedItem.transported_to != null
                                                                                                                              ?  selectedItem.transported_to
                                                                                                                              :  "---", style: 'normal'}]},
                   {lineHeight: 1.5, text: [{text: "Injured Body Part(s):    ", style: ['normalBold']},
                                            {text: this.stringArrayToString(other_form_data.injured_body), style: 'normal'}]},
                   {lineHeight: 1.5, text: [{text: "Left:    ", style: ['normalBold', { leadingIndent: 20}]},
                                            {text: this.stringArrayToString(other_form_data.injured_left), style: 'normal'}]},
                   {lineHeight: 1.5, text: [{text: "Right:    ", style: ['normalBold', { leadingIndent: 20}]},
                                            {text: this.stringArrayToString(other_form_data.injured_right), style: 'normal'}]},
                   {lineHeight: 1.5, text: [{text: "Observations:    ", style: ['normalBold', {marginLeft: "50px"}]},
                           {text: this.stringArrayToString(other_form_data.observations), style: 'normal'},
                           {text: other_form_data.other_behavior_observations != null ? ", "+ other_form_data.other_behavior_observations : "", style: ['normal']}]},
                   {lineHeight: 1.5, text: [{text: "Note any other observations or details regarding the above, including RIGHT/LEFT side of the body, etc:    ",style: ['normalBoldAlignLeft']},
                            {text: other_form_data.location_observation != null ? other_form_data.location_observation : "---", style: ['normal']}]},

                   {lineHeight: 1.5, text: "**If in-house or external medical treatment declined, please have guest sign a Declination & Release Form-Forward Emergency Medical Treatment reportsandRelease formsto Risk Management -", style: ['title', {color: "green"}]},
                   {canvas: [{ type: 'line', x1: 0, y1: 5, x2: 595-2*40, y2: 5, lineWidth: 1 }]},
                   {lineHeight: 1.5, text: "LOCATION: ", style: ['normalBoldAlignLeft', {color: 'red'}]},
                   {lineHeight: 1.5, text: "***Please take photographs to support report –send to Risk Management***", style: ['normal', {bold: true, color: 'blue', alignment: 'center'}]},
                   {lineHeight: 1.5, text: [{text: "Provide specific details on the EXACT location (e.g. restaurant, bar, music hall section, kitchen, stage, restrooms, etc.):    ",style: ['normalBoldAlignLeft']},
                            {text: selectedItem.facility_name != null ? selectedItem.facility_name : "(No Facility Name)"+ ", " + other_form_data.address != null ? other_form_data.address : "(No Address)", style: 'normal'}]},
                    {lineHeight: 1.5, text: [{text: "Occupancy :    ", style: 'normalBold'},
                             {text: other_form_data.occupancy != null ? other_form_data.occupancy : "---", style: 'normal'},
                             {text: " Other:  " + other_form_data.occupancy_other != null ? other_form_data.occupancy_other : "---", style: ['normal']}]},
                   {lineHeight: 1.5, text: "Lighting Conditions:    ", style: 'normalBold'},
                   {lineHeight: 1.5, text: [{text: "Club:    ", style: ['normalBold', { leadingIndent: 20}]},
                                            {text: other_form_data.lighting_club != null ? other_form_data.lighting_club : "---", style: 'normal'}]},
                  {lineHeight: 1.5, text: [{text: "Restaurant:    ", style: ['normalBold', { leadingIndent: 20}]},
                                           {text: other_form_data.lighting_restaurant != null ? other_form_data.lighting_restaurant : "---", style: 'normal'}]},
                   {lineHeight: 1.5, text: [{text: "Exterior:    ", style: ['normalBold', { leadingIndent: 20}]},
                                            {text: other_form_data.lighting_exterior != null ? other_form_data.lighting_exterior : "---", style: 'normal'}]},
                  {lineHeight: 1.5, text: [{text: "Burned/Out:    ", style: ['normalBold', { leadingIndent: 20}]},
                                           {text: other_form_data.lighting_burned_out != null ? other_form_data.lighting_burned_out : "---", style: 'normal'}]},
                    {lineHeight: 1.5, text: [{text: "Other observations or specific details regarding location:    ", style: 'normalBold'},
                             {text: other_form_data.location_desc != null ? other_form_data.location_desc : "---", style: 'normal'}]},
                   {canvas: [{ type: 'line', x1: 0, y1: 5, x2: 595-2*40, y2: 5, lineWidth: 1 }]},
                   {lineHeight: 1.5, text: "GUEST DETAILS: ", style: ['normalBoldAlignLeft', {color: 'red'}]},
                   {lineHeight: 1.5, text: "***Please take photographs to support report –send to Risk Management***", style: ['normal', {bold: true, color: 'blue', alignment: 'center'}]},
                   {lineHeight: 1.5, text: [{text: "Did shoes / clothing contribute to the accident?: ",style: ['normalBoldAlignLeft']},
                            {text: other_form_data.clothes_contribute != null
                                        ? other_form_data.clothes_contribute
                                          ? "    Yes"
                                          : "    No"
                                        : "---", style: 'normal'},

                          ]},
                    {lineHeight: 1.5, text: [{text: "Condition of the floor/steps:    ", style: 'normalBold'},
                            {text: this.stringArrayToString(other_form_data.conditions), style: 'normal'},]},
                    {lineHeight: 1.5, text: [{text: "Note other relevant details:    ", style: 'normalBold'},
                            {text: other_form_data.condition_other != null
                                        ? other_form_data.condition_other
                                        : "---" , style: 'normal'},]},
                    {pageBreak: 'before', columns: [
                      {width: 300, text: [{text: "Venue Name: ",
                                             style: ['normal', {bold: true}]},
                                           {text: selectedItem.facility_name != null ? selectedItem.facility_name : "---", style: ['normal', {decoration: "underline"}]},
                                         ], lineHeight: 1.5, },
                      {width: 200, text: [{text: "Date: ",
                                             style: ['normal', {bold: true}]},
                                           {text: moment(selectedItem.date_added).format("MM-DD-YYYY h:mm A"), style: ['normal', {decoration: "underline"}]},
                                         ], lineHeight: 1.5, }]},
                   {lineHeight: 1.5, text: " ", style: 'normal'},
                   {canvas: [{ type: 'line', x1: 0, y1: 5, x2: 595-2*40, y2: 5, lineWidth: 1 }]},
                    {lineHeight: 1.5, text: "POLICE / SECURITY: ", style: ['normalBoldAlignLeft', {color: 'red'}]},
                    {lineHeight: 1.5, text: "***Attach copy of police Incident Report if available***", style: ['normal', {bold: true, color: 'blue', alignment: 'center'}]},
                    {columns: [
                      {width: 200, lineHeight: 1.5, text: [{text: "Police Called: ",
                                             style: ['normal', {bold: true}]},
                                           {text: other_form_data.police_called != null
                                                  ? other_form_data.police_called
                                                      ? "    Yes"
                                                      : "    No"
                                                  : "---", style: 'normal'},
                                         ]},
                      {width: 300, lineHeight: 1.5, text: [{text: "Was a Police Report Taken: ",
                                             style: ['normal', {bold: true}]},
                                           {text: other_form_data.police_report != null
                                                      ? other_form_data.police_report
                                                          ? "    Yes"
                                                          : "    No"
                                                      : "---", style: 'normal'},
                                         ]}]},
                   {lineHeight: 1.5, text: [{text: "Police report Officer’s name (obtain business card & attach):    ", style: ['normal', {bold: true}]},
                                            {text: other_form_data.police_officer ? other_form_data.police_officer : "---", style: 'normal'}]},
                    {lineHeight: 1.5, text: [{text: "Was anyone ejected?    ", style: ['normal', {bold: true}]},
                            {text: other_form_data.police_ejected != null
                                                ? other_form_data.police_ejected
                                                    ? "Yes"
                                                    : "No"
                                                : "---", style: 'normal'}]},
                    {lineHeight: 1.5, text: [{text: "Was anyone arrested?    ", style: ['normal', {bold: true}]},
                            {text: other_form_data.police_arrested != null
                                          ? other_form_data.police_arrested
                                              ? "Yes"
                                              : "No"
                                          : "---", style: 'normal'}]},
                    {lineHeight: 1.5, text: [{text: "Names of Arrested:    ",
                                         style: ['normal', {bold: true}]},
                                       {text: other_form_data.names_of_arrested != null ? other_form_data.names_of_arrested : "---", style: 'normal'},
                                     ]},
                   {lineHeight: 1.5, text: [{text: "Charges?    ", style: ['normal', {bold: true}]},
                                      {text: other_form_data.charges != null ? other_form_data.charges : "---", style: 'normal'},
                                    ]},
                   {lineHeight: 1.5, text: [{text: "Details of Arrest:    ", style: ['normal', {bold: true}]},
                                       {text: other_form_data.arrest_details != null ? other_form_data.arrest_details : "---", style: 'normal'},
                                    ]},
                   {lineHeight: 1.5, text: " ", style: 'normal'},
                   {canvas: [{ type: 'line', x1: 0, y1: 5, x2: 595-2*40, y2: 5, lineWidth: 1 }]},
                   {lineHeight: 1.5, text: "WITNESSES ", style: ['normalBoldAlignLeft', {color: 'red'}]},
                   {lineHeight: 1.5, columns: [
                     {width: 200, lineHeight: 1.5, text: [{text: "Witness #1: Name:    ",
                                            style: ['normal', {bold: true}]},
                                          {text: witnesses[0].name ? witnesses[0].name : "---", style: 'normal'},
                                        ]},
                     {width: 100, lineHeight: 1.5, text: [{text: "  Phone: ",
                                            style: ['normal', {bold: true}]},
                                          {text: witnesses[0].phone ? witnesses[0].phone : "---", style: 'normal'},
                                        ]},
                      {width: 200, lineHeight: 1.5, text: [{text: "  Relationship: ",
                                             style: ['normal', {bold: true}]},
                                           {text: witnesses[0].relationship ? witnesses[0].relationship : "---", style: 'normal'},
                                         ]}]},
                   {lineHeight: 1.5, text: [{text: "Address: ", style: ['normal', {bold: true}]},
                                       {text: witnesses[0].address ? witnesses[0].address : "---", style: 'normal'},
                                    ]},
                   {lineHeight: 1.5, text: [{text: "Witness description of incident:    ", style: ['normal', {bold: true}]},
                                        {text: witnesses[0].description ? witnesses[0].description : "---", style: 'normal'},
                                     ]},
                   {lineHeight: 1.5, columns: [
                     {width: 200, lineHeight: 1.5, text: [{text: "Witness #2: Name:    ",
                                            style: ['normal', {bold: true}]},
                                          {text: witnesses[1].name ? witnesses[1].name : "---", style: 'normal'},
                                        ]},
                     {width: 100, lineHeight: 1.5, text: [{text: "  Phone: ",
                                            style: ['normal', {bold: true}]},
                                          {text: witnesses[1].phone ? witnesses[1].phone : "---", style: 'normal'},
                                        ]},
                      {width: 200, lineHeight: 1.5, text: [{text: "  Relationship: ",
                                             style: ['normal', {bold: true}]},
                                           {text: witnesses[1].relationship ? witnesses[1].relationship: "---", style: 'normal'},
                                         ]}]},
                   {lineHeight: 1.5, text: [{text: "Address: ", style: ['normal', {bold: true}]},
                                       {text: witnesses[1].address ? witnesses[1].address : "---", style: 'normal'},
                                    ]},
                   {lineHeight: 1.5, text: [{text: "Witness description of incident:    ", style: ['normal', {bold: true}]},
                                        {text: witnesses[1].description ? witnesses[1].description : "---", style: 'normal'},
                                     ]},
                   {lineHeight: 1.5, text: [{text: "If witness knows patron, any awareness of medical condition/physical impairment that may be related to this incident? ", style: ['normal', {bold: true}]},
                                       {text: selectedItem.police_medical_condition ? selectedItem.police_medical_condition : "---", style: 'normal'},
                                    ]},
                  {lineHeight: 1.5, text: [{text: "Venue Staff Witness #1:    ", style: ['normal', {bold: true}]},
                                      {text: staffWitnesses[0].description ? staffWitnesses[0].description : "---", style: 'normal'},
                                   ]},
                  {lineHeight: 1.5,text: [{text: "Venue Staff Witness #2:    ", style: ['normal', {bold: true}]},
                                       {text: staffWitnesses[1].description ? staffWitnesses[1].description : "---", style: 'normal'},
                                    ], pageBreak: 'after'},


                {columns: [
                  {width: 300, text: [{text: "Venue Name: ",
                                         style: ['normal', {bold: true}]},
                                      {text: selectedItem.facility_name != null ? selectedItem.facility_name : "---", style: ['normal', {decoration: "underline"}]},
                                     ], lineHeight: 1.5, },
                  {width: 200, text: [{text: "Date: ",
                                         style: ['normal', {bold: true}]},
                                       {text: moment(selectedItem.date_added).format("MM-DD-YYYY h:mm A"), style: ['normal', {decoration: "underline"}]},
                                     ], lineHeight: 1.5, }]},
                 {lineHeight: 1.5, text: " ", style: 'normal'},
                 {canvas: [{ type: 'line', x1: 0, y1: 5, x2: 595-2*40, y2: 5, lineWidth: 1 }]},
                  {lineHeight: 1.5, text: "PROPERTY DAMAGE: ", style: ['normalBoldAlignLeft', {color: 'red'}]},
                  {lineHeight: 1.5, text: "***Please take photographs to support report –send to Risk Management***", style: ['normal', {bold: true, color: 'blue', alignment: 'center'}]},
                  {lineHeight: 1.5, text: [{text: "Describe specific asset damage(fire, water leak, etc.) and circumstances:    ", style: ['normal', {bold: true}]},
                                      {text: other_form_data.asset_damage ? other_form_data.asset_damage : "---", style: 'normal'},
                                   ]},
                  {lineHeight: 1.5, text: [{text: "Estimated value of damage:    ", style: ['normal', {bold: true}]},
                                   {text: other_form_data.damage_value ? other_form_data.damage_value : "---", style: 'normal'},
                                ]},
                  {lineHeight: 1.5, text: [{text: "Immediate mediation required?    ", style: ['normal', {bold: true}]},
                                            {text: other_form_data.immediate_mediation != null
                                                      ? other_form_data.immediate_mediation
                                                          ? "    Yes"
                                                          : "    No"
                                                      : "---", style: 'normal'},
                                            {text: "      Contractor(s) Dispatched:   ", style: ['normal', {bold: true}]},
                                            {text: other_form_data.contractor_dispatch ? other_form_data.contractor_dispatch : "---", style: 'normal'},
                                ]},
                  {lineHeight: 1.5, text: [{text: "Other details: ", style: ['normal', {bold: true}]},
                                   {text: other_form_data.property_other_details ? other_form_data.property_other_details : "---", style: 'normal'},
                                ]},
                  {lineHeight: 1.5, text: "Submit copies of property damage reports to: janberger@livenation.comC all 323 769-4347 if damage >$5,000.", style: ['normal', {bold: true, color: 'blue', alignment: 'center'}]},
                   {canvas: [{ type: 'line', x1: 0, y1: 5, x2: 595-2*40, y2: 5, lineWidth: 1 }]},
                  {lineHeight: 1.5, text: [{text: "ADDITIONAL OBSERVATIONS OR COMMENTS:    ", style: ['normalBoldAlignLeft', {color: "red", decoration: "underline"}]},
                                   {text: other_form_data.additional_observations ? other_form_data.additional_observations : "---", style: 'normal'},
                                ]},//Add character limit
                  {lineHeight: 1.5, text: " ", style: 'normal'},
                  {lineHeight: 1.5, text: " ", style: 'normal'},
                  //{other_form_data.investigating_manager_name
                   {columns: [
                     {text: other_form_data.general_manager_name, style: 'normal', decoration: "underline"},
                  //   {canvas: [{ type: 'line', x1: 0, y1: 5, x2: 200, y2: 5, lineWidth: 1 }]},
                     {canvas: [{ type: 'line', x1: 0, y1: 5, x2: 200, y2: 5, lineWidth: 1 }]}]},
                  {columns: [
                    {width: 300, text: {text: "INVESTIGATING MANAGER'S NAME (PRINT)", style: ['normal', {italics: true}]}, lineHeight: 1.5},
                    {width: 200, text: {text: "INVESTIGATING MANAGER'S SIGNATURE", style: ['normal', {italics: true}]}, lineHeight: 1.5, }]},
                  {lineHeight: 1.5, text: " ", style: 'normal'},
                  {lineHeight: 1.5, text: " ", style: 'normal'},
                  {columns: [
                    {text: other_form_data.investigating_manager_name, style: 'normal', decoration: "underline"},
                    {canvas: [{ type: 'line', x1: 0, y1: 5, x2: 200, y2: 5, lineWidth: 1 }]}]},
                  {columns: [
                    {width: 300, text: {text: "GENERAL MANAGER (PRINT)", style: ['normal', {italics: true}]}, lineHeight: 1.5},
                    {width: 200, text: {text: "GENERAL MANAGER SIGNATURE", style: ['normal', {italics: true}]}, lineHeight: 1.5}]},
                    this.renderRefusal(selectedItem, other_form_data),
               ]

     var docDef = {
       header: (currentPage, pageCount, pageSize) => {

                       if(currentPage == pageCount && !other_form_data.first_aid_accepted) {
                         return [
                           {text: " "},
                           {
                             width: 160,
                             image: this.returnLiveNationLogoUrl(), style: {alignment: 'center'}
                           }
                         ]

                       } else {
                         return [
                           {text: " ", style: ['title', {color: "blue"}]},
                           {text: " ", style: ['title', {color: "blue"}]},
                           {text: "Page "+currentPage, style: ['title']},
                           {text: "Venue Incident Report - Guest Claim / Property Damage", style: ['title', {color: "blue"}]},
                           {text: "** ATTORNEY CLIENT PRIVILEGED & CONFIDENTIAL -DISTRIBUTE ONLY TO GENERAL MANAGER& RISK MANAGEMENT**", style: ['title', {color: "red"}]},
                           {text: "PROPERTY OF LIVE NATION: DO NOT COPY / DO NOT PROVIDE TO GUEST", style: ["title", {color: "red", decoration: "underline"}]},
                           {text: " ", style: 'normal'},
                         ]
                       }

                      },
                    content: content,
                    styles: styles,
                    pageMargins: [20, 70, 20, 20],
                  }

    return docDef;
     // this.setState({
     //   liveNationPDFDocDefinition: docDef
     // })
    }

    prepLiveNationPDFDocDefinitionEmployee(selectedItem) {
      var styles = {
        title: {
          fontSize: 10,
          bold: true,
          alignment: 'center',
        },
        header: {
          fontSize: 11,
          alignment: 'center',
          color: '#785448'
        },
        normal: {
          fontSize: 9,
        },
        normalBold: {
          fontSize: 9,
          bold: true,
        },
        normalIndented: {
          fontSize: 10,
          leadingIndent: 15,
          color: '#785448'
        },
        normalCenteredBold: {
          fontSize: 10,
          alignment: 'center',
          bold: true,
          color: '#785448'
        },
        normalBoldAlignLeft: {
          fontSize: 10,
          alignment: 'left',
          bold: true,
        }
      };

      if(typeof(selectedItem) == "undefined"){
          selectedItem = {};
      }
      //console.log("selectedItem: ", selectedItem);
      var other_form_data = UtilsService.sharedInstance.tryParseJSON(selectedItem.other_form_data) ? JSON.parse(selectedItem.other_form_data) : {};
      let emptyWitnesses = [{"name":"","phone":"","relationship":"","description":""}, {"name":"","phone":"","relationship":"","description":""}];
      var individual_data = selectedItem.individuals_data
                                      ? JSON.parse(selectedItem.individuals_data)
                                          ? JSON.parse(selectedItem.individuals_data)[0]
                                          : {}
                                      : {};

      //initialize these data to avoid error in PDF download
      var witnesses = other_form_data.witnesses ? other_form_data.witnesses : emptyWitnesses;
      //console.log("individual_data: ", individual_data);

      //console.log("other_form_data: ", other_form_data);
      //console.log("individual_data.condition_injured: ", individual_data.condition_injured);
      var content = [{columns: [
                                 {width: 200, text: [{text: "Venue Name: ",
                                                        style: ['normal', {bold: true}]},
                                                      {text: selectedItem.facility_name != null ? selectedItem.facility_name : "---", style: ['normal']},
                                                    ], lineHeight: 1.5, },
                                 {width: 200, text: [{text: "Address: ",
                                                        style: ['normal', {bold: true}]},
                                                      {text: other_form_data.address ? other_form_data.address : this.createUnderline(30), style: ['normal']},
                                                    ], lineHeight: 1.5, },
                                  {width: 200, text: [{text: "Date: ",
                                                         style: ['normal', {bold: true}]},
                                                       {text: selectedItem.date_added ? moment(selectedItem.date_added).format("MM-DD-YYYY h:mm A") : this.createUnderline(40), style: ['normal']},
                                                     ], lineHeight: 1.5, }]},

                       {lineHeight: 1.5, text: " ", style: 'normal'},
                       {columns: [
                                  {width: 200, text: [{text: "Incident Involves: ",
                                                         style: ['normal', {bold: true}]},
                                                       {text: other_form_data.incident_involve != null ? other_form_data.incident_involve : "---", style: ['normal']},
                                                     ], lineHeight: 1.5, },
                                  {width: 200, text: [{text: "Tape on File: ",
                                                         style: ['normal', {bold: true}]},
                                                       {text: other_form_data.tape_on_file ? "Yes" : "No", style: ['normal']},
                                                     ], lineHeight: 1.5, },]},
                       {columns: [
                                  {width: 200, text: [{text: "Injured Name: ",
                                                         style: ['normal', {bold: true}]},
                                                       {text: individual_data.name != null ? individual_data.name : "---", style: ['normal']},
                                                     ], lineHeight: 1.5, },
                                  {width: 200, text: [{text: "Incident Date: ",
                                                         style: ['normal', {bold: true}]},
                                                       {text: other_form_data.incident_date ? other_form_data.incident_date : "---", style: ['normal']},
                                                     ], lineHeight: 1.5, },
                                   {width: 200, text: [{text: "Incident Time: ",
                                                          style: ['normal', {bold: true}]},
                                                        {text: other_form_data.incident_time ? other_form_data.incident_time : "---", style: ['normal']},
                                                      ], lineHeight: 1.5, },]},

                      {columns: [
                                 {width: 150, text: [{text: "Gender: ",
                                                        style: ['normal', {bold: true}]},
                                                      {text: individual_data.gender != null ? individual_data.gender : "---", style: ['normal']},
                                                    ], lineHeight: 1.5, },
                                 {width: 250, text: [{text: "Injured Position: ",
                                                        style: ['normal', {bold: true}]},
                                                      {text: individual_data.position ? individual_data.position : "---", style: ['normal']},
                                                    ], lineHeight: 1.5, },
                                  {width: 200, text: [{text: "Date of Hire: ",
                                                         style: ['normal', {bold: true}]},
                                                       {text: individual_data.hired_date ? individual_data.hired_date : "---", style: ['normal']},
                                                     ], lineHeight: 1.5, },]},
                    {canvas: [{ type: 'line', x1: 0, y1: 5, x2: 595-2*40, y2: 5, lineWidth: 1 }]},
                     {lineHeight: 1.5, text: " ", style: 'normal'},
                     {columns: [
                                {width: 280, text: [{text: "Soical Security Number: ",
                                                       style: ['normal', {bold: true}]},
                                                     {text: individual_data.ssn != null ? individual_data.ssn : "---", style: ['normal']},
                                                   ], lineHeight: 1.5, },
                                {width: 150, text: [{text: "Date of Birth: ",
                                                       style: ['normal', {bold: true}]},
                                                     {text: individual_data.birthday ? individual_data.birthday : "---", style: ['normal']},
                                                   ], lineHeight: 1.5, },]},
                     {lineHeight: 1.5, text: [{text: "Employer (if not Live Nation): ", style: ['normal', {bold: true}]},
                                         {text: individual_data.employer ? individual_data.employer : "---", style: 'normal'},
                                      ]},
                    {text: [{text: "How did the incident occur?  ",
                                           style: ['normal', {bold: true}]},
                                         {text: individual_data.how_incident_occur ? individual_data.how_incident_occur : this.createUnderline(500) , style: 'normal'},
                                       ]},
                     {lineHeight: 1.5, text: " ", style: 'normal'},
                     {columns: [
                                {width: 250, text: [{text: "Any Evidence Of alcohol/drug intoxication: ",
                                                       style: ['normal', {bold: true}]},
                                                     {text: individual_data.evidence != null ? "Yes" : "No", style: ['normal']},
                                                   ], lineHeight: 1.5, },
                                {width: 250, text: [{text: "Describe: ",
                                                       style: ['normal', {bold: true}]},
                                                     {text: individual_data.describe_evidence ? individual_data.describe_evidence : "---", style: ['normal']},
                                                   ], lineHeight: 1.5, },]},
                     {text: [{text: "Injured's medical condition or physical impairment that may be related to this incident?  ",
                                            style: ['normal', {bold: true}]},
                                          {text: individual_data.condition_injured ? individual_data.condition_injured : this.createUnderline(200) , style: 'normal'},
                                        ]},
                      {text: [{text: "Describe details on the EXACT location of injury (restaurant, bar, music hall section, kitchen, stage, restrooms, etc.)  ",
                                             style: ['normal', {bold: true}]},
                                           {text: individual_data.location_observation ? individual_data.location_observation : this.createUnderline(200) , style: 'normal'},
                                         ]},
                       {lineHeight: 1.5, text: " ", style: 'normal'},
                       {canvas: [{ type: 'line', x1: 0, y1: 5, x2: 595-2*40, y2: 5, lineWidth: 1 }]},
                        {lineHeight: 1.5, text: "MEDICAL: ", style: ['normalBoldAlignLeft', {color: 'red'}]},
                        {lineHeight: 1.5, text: " ", style: 'normal'},
                        {lineHeight: 1.5, text: [{text: "Venue First Aid (ice pack, band-aid, etc.):    ", style: 'normalBold'}, {text: other_form_data.first_aid != null
                                                                                                                                                 ? other_form_data.first_aid
                                                                                                                                                    ? "Accepted"
                                                                                                                                                    : "Declined"
                                                                                                                                                  : "---", style: 'normal'}]},
                        {columns: [
                          {width: 200, lineHeight: 1.5, text: [{text: "Paramedics Called:    ",
                                                 style: ['normal', {bold: true}]},
                                               {text: other_form_data.paramedics_called != null
                                                            ? other_form_data.paramedics_called
                                                              ? "Yes"
                                                              : "No"
                                                            : "---", style: 'normal'},
                                             ]},
                          {width: 300, lineHeight: 1.5, text: [{text: "Offsite Emergency Care:    ",
                                                 style: ['normal', {bold: true}]},
                                               {text: other_form_data.offsite_emergency_care != null
                                                            ? this.stringArrayToString(other_form_data.offsite_emergency_care)
                                                            : "---", style: 'normal'},
                                             ]}]},
                       {lineHeight: 1.5, text: [{text: "If treated offsite, transported by:    ", style: 'normalBold'},
                                {text: other_form_data.transportation_explanation
                                              ? other_form_data.transportation_explanation
                                              : other_form_data.transported_by, style: 'normal'}]},
                       {canvas: [{ type: 'line', x1: 0, y1: 5, x2: 595-2*40, y2: 5, lineWidth: 1 }]},
                       {lineHeight: 1.5, text: " ", style: 'normalBold'},
                       {lineHeight: 1.5, text: [{text: "Transported to (medical facility):     ", style: 'normalBold'}, {text: other_form_data.transported_to != null
                                                                                                                                  ?  other_form_data.transported_to
                                                                                                                                  :  "---", style: 'normal'}]},
                       {lineHeight: 1.5, text: [{text: "Injured Body Part(s):    ", style: ['normalBold']},
                                                {text: this.stringArrayToString(other_form_data.injured_body), style: 'normal'}]},
                       {lineHeight: 1.5, text: [{text: "Left:    ", style: ['normalBold', { leadingIndent: 20}]},
                                                {text: this.stringArrayToString(other_form_data.injured_left), style: 'normal'}]},
                       {lineHeight: 1.5, text: [{text: "Right:    ", style: ['normalBold', { leadingIndent: 20}]},
                                                {text: this.stringArrayToString(other_form_data.injured_right), style: 'normal'}]},
                       {lineHeight: 1.5, text: [{text: "Observations:    ", style: ['normalBold', {marginLeft: "50px"}]},
                               {text: this.stringArrayToString(other_form_data.observations), style: 'normal'},
                               {text: other_form_data.other_behavior_observations != null ? ", "+ other_form_data.other_behavior_observations : "", style: ['normal']}]},
                       {lineHeight: 1.5, text: [{text: "Other Medical Observations: ",style: ['normalBoldAlignLeft']},
                                {text: other_form_data.observations_others != null ? other_form_data.observations_others :this.createUnderline(300), style: ['normal']}]},

                        {pageBreak: "before", columns: [
                               {width: 200, text: [{text: "Venue Name: ",
                                                      style: ['normal', {bold: true}]},
                                                    {text: selectedItem.facility_name != null ? selectedItem.facility_name : "---", style: ['normal']},
                                                  ], lineHeight: 1.5, },
                               {width: 200, text: [{text: "Address: ",
                                                      style: ['normal', {bold: true}]},
                                                    {text: other_form_data.address ? other_form_data.address : this.createUnderline(30), style: ['normal']},
                                                  ], lineHeight: 1.5, },
                                {width: 200, text: [{text: "Date: ",
                                                       style: ['normal', {bold: true}]},
                                                     {text: selectedItem.date_added ? moment(selectedItem.date_added).format("MM-DD-YYYY h:mm A") : this.createUnderline(40), style: ['normal']},
                                                   ], lineHeight: 1.5, }]},
                       {canvas: [{ type: 'line', x1: 0, y1: 5, x2: 595-2*40, y2: 5, lineWidth: 1 }]},
                       {lineHeight: 1.5, text: "WITNESSES ", style: ['normalBoldAlignLeft', {color: 'red'}]},
                       {lineHeight: 1.5, columns: [
                         {width: 200, lineHeight: 1.5, text: [{text: "Witness #1: Name:    ",
                                                style: ['normal', {bold: true}]},
                                              {text: witnesses[0].name ? witnesses[0].name : "---", style: 'normal'},
                                            ]},
                         {width: 100, lineHeight: 1.5, text: [{text: "  Phone: ",
                                                style: ['normal', {bold: true}]},
                                              {text: witnesses[0].phone ? witnesses[0].phone : "---", style: 'normal'},
                                            ]},
                          {width: 200, lineHeight: 1.5, text: [{text: "  Relationship: ",
                                                 style: ['normal', {bold: true}]},
                                               {text: witnesses[0].relationship ? witnesses[0].relationship : "---", style: 'normal'},
                                             ]}]},
                       {lineHeight: 1.5, text: [{text: "Address: ", style: ['normal', {bold: true}]},
                                           {text: witnesses[0].address ? witnesses[0].address : "---", style: 'normal'},
                                        ]},
                       {lineHeight: 1.5, text: [{text: "Witness description of incident:    ", style: ['normal', {bold: true}]},
                                            {text: witnesses[0].description ? witnesses[0].description : "---", style: 'normal'},
                                         ]},
                       {lineHeight: 1.5, columns: [
                         {width: 200, lineHeight: 1.5, text: [{text: "Witness #2: Name:    ",
                                                style: ['normal', {bold: true}]},
                                              {text: witnesses[1].name ? witnesses[1].name : "---", style: 'normal'},
                                            ]},
                         {width: 100, lineHeight: 1.5, text: [{text: "  Phone: ",
                                                style: ['normal', {bold: true}]},
                                              {text: witnesses[1].phone ? witnesses[1].phone : "---", style: 'normal'},
                                            ]},
                          {width: 200, lineHeight: 1.5, text: [{text: "  Relationship: ",
                                                 style: ['normal', {bold: true}]},
                                               {text: witnesses[1].relationship ? witnesses[1].relationship: "---", style: 'normal'},
                                             ]}]},
                       {lineHeight: 1.5, text: [{text: "Address: ", style: ['normal', {bold: true}]},
                                           {text: witnesses[1].address ? witnesses[1].address : "---", style: 'normal'},
                                        ]},
                       {lineHeight: 1.5, text: [{text: "Witness description of incident:    ", style: ['normal', {bold: true}]},
                                            {text: witnesses[1].description ? witnesses[1].description : this.createUnderline(300), style: 'normal'},
                                         ]},
                      {lineHeight: 1.5, text: " ", style: 'normal'},
                      {canvas: [{ type: 'line', x1: 0, y1: 5, x2: 595-2*40, y2: 5, lineWidth: 1 }]},
                       {lineHeight: 1.5, text: "ADDITIONAL CLAIM DETAIL: ", style: ['normalBoldAlignLeft', {color: 'red'}]},
                       {text: this.createUnderline(500),
                                              style: ['normal', {bold: true}]},
                       {lineHeight: 1.5, text: " ", style: 'normal'},
                       {lineHeight: 1.5, text: " ", style: 'normal'},
                        {columns: [
                          {text: other_form_data.investigating_manager_name, style: 'normal', decoration: "underline"},
                          {text: other_form_data.investigating_manager_signature, style: 'normal', decoration: "underline"},]},
                       {columns: [
                         {width: 300, text: {text: "INVESTIGATING MANAGER'S NAME (PRINT)", style: ['normal', {italics: true}]}, lineHeight: 1.5},
                         {width: 200, text: {text: "INVESTIGATING MANAGER'S SIGNATURE", style: ['normal', {italics: true}]}, lineHeight: 1.5, }]},
                       {lineHeight: 1.5, text: " ", style: 'normal'},
                       {lineHeight: 1.5, text: " ", style: 'normal'},
                       {columns: [
                         {text: other_form_data.general_manager_name, style: 'normal', decoration: "underline"},
                         {text: other_form_data.general_manager_signature, style: 'normal', decoration: "underline"},]},
                       {columns: [
                         {width: 300, text: {text: "GENERAL MANAGER (PRINT)", style: ['normal', {italics: true}]}, lineHeight: 1.5},
                         {width: 200, text: {text: "GENERAL MANAGER SIGNATURE", style: ['normal', {italics: true}]}, lineHeight: 1.5}]},
                      this.renderAuthorization(selectedItem, other_form_data, individual_data),
                      this.renderRefusal(selectedItem, other_form_data, "employee"),//change to renderRefusalEmployee later
                    ];

      var docDef = {
        header: (currentPage, pageCount, pageSize) => {

                        if(currentPage >= pageCount - 1 && !other_form_data.first_aid_accepted) {
                          return [
                                    {text: " "},
                                    {
                                      width: 160,
                                      image: this.returnLiveNationLogoUrl(), style: {alignment: 'center'}
                                    }
                                  ]

                        } else {
                          return [
                            {text: " ", style: ['title', {color: "blue"}]},
                            {text: " ", style: ['title', {color: "blue"}]},
                            {text: "Page "+currentPage, style: ['title']},
                            {text: "Worker's Compensation / OSHA 301 Incident Report", style: ['title', {color: "blue"}]},
                            {text: "** ATTORNEY CLIENT PRIVILEGED & CONFIDENTIAL -DISTRIBUTE ONLY TO GENERAL MANAGER& RISK MANAGEMENT**", style: ['title', {color: "red"}]},
                            {text: "PROPERTY OF LIVE NATION: DO NOT COPY / DO NOT PROVIDE TO EMPLOYEE", style: ["title", {color: "red", decoration: "underline"}]},
                            {text: " ", style: 'normal'},
                          ]
                        }

                       },
                     content: content,
                     styles: styles,
                     pageMargins: [20, 70, 20, 20],
                   }

     return docDef;

    }

    returnLiveNationLogoUrl(){
        //generate image
        const imgToExport = document.getElementById('liveNationLogo');
        const canvas = document.createElement('canvas');
                  canvas.width = imgToExport.width; 
                  canvas.height = imgToExport.height; 
                  canvas.getContext('2d').drawImage(imgToExport, 0, 0);
        const liveNationLogoURL =canvas.toDataURL('image/png');
        return liveNationLogoURL;
    }

    renderAuthorization(selectedItem, other_form_data, individual_data) {
      var refusal_of_medical_treatment_form = other_form_data.refusal_of_medical_treatment_form;
      var natureOfInjury = refusal_of_medical_treatment_form && refusal_of_medical_treatment_form.refusal_condition ? refusal_of_medical_treatment_form.refusal_condition : null;
      var injuredWorker = other_form_data.injured_worker;
      var incidentDate = other_form_data.incident_date;
      var employerName = individual_data.employer;
      var localChapter = other_form_data.union_local_chapter;
      var authorizationLocation = other_form_data.authorization_location;
      var representative = other_form_data.representative;
      var representativeSignature = other_form_data.representative_signature;
      var representativePhone = other_form_data.representative_phone;
      var treatmentFacility = other_form_data.treatment_facility;
      var physician = other_form_data.physician;
      var physicianSignature = other_form_data.physician_signature;

      return [
              {pageBreak: "before", lineHeight: 1.5, text: " ", style: 'normal'},
              {text: "AUTHORIZATION FOR MEDICAL TREATMENT - EMPLOYEE INJURY", style: ['normalBold', 'title']},
              {text: "THE  PERSON  NAMED  BELOW  IS  BEING  REFERREDTO  YOU  FOR  TREATMENTAS  A RESULT  OF"
                      + "AN  INJURY ALLEGEDLY  INCURRED  WHILE  WORKING  FOR  LIVE  NATION ENTERTAINMENT OR ONEOF ITS SUBSIDIARIES. "
                      + "THIS FORM MUST BESIGNED BY AN AUTHORIZED LIVE NATION REPRESENTATIVE FOR APPROVAL", style: ['title']},
              {lineHeight: 1.5, text: " ", style: 'normal'},
              {lineHeight: 1.5, text: " ", style: 'normal'},
              {columns: [
                {width: 350, lineHeight: 1.5, text: {lineHeight: 1.5, text: injuredWorker ? injuredWorker : this.createUnderline(40), style: ['normal', this.processUnderline(injuredWorker)]},},
                {width: 200, lineHeight: 1.5, text: {lineHeight: 1.5, text: incidentDate ? incidentDate : this.createUnderline(40), style: ['normal', this.processUnderline(incidentDate)]}},]},

              {columns: [
                {width: 350, lineHeight: 1.5, text: {text: "Injured Worker (Last, First, Middle Initial)",
                                       style: ['normal', {bold: true}]}},
                 {width: 200, lineHeight: 1.5, text: {text: "Incident Date",
                                        style: ['normal', {bold: true}]}},]},
              {lineHeight: 1.5, text: " ", style: 'normal'},

              {columns: [
                {width: 350, lineHeight: 1.5,  text: {lineHeight: 1.5, text: employerName ? employerName : this.createUnderline(40), style: ['normal', this.processUnderline(employerName)]}},
                {width: 200, lineHeight: 1.5, text: {lineHeight: 1.5, text: localChapter ? localChapter : this.createUnderline(40), style: ['normal', this.processUnderline(localChapter)]}},]},

              {columns: [
                {width: 350, lineHeight: 1.5, text: {text: "Employer Name (Live Nation, Union, Contractor, etc.)",
                                       style: ['normal', {bold: true}]}},
                 {width: 200, lineHeight: 1.5, text: {text: "If Union, Local Chapter",
                                        style: ['normal', {bold: true}]}},]},
              {lineHeight: 1.5, text: " ", style: 'normal'},
               {text: authorizationLocation ? authorizationLocation : this.createUnderline(48), style: ['normal', this.processUnderline(authorizationLocation)]},
               {text: "Location (Venue, City State)",
                                      style: ['normal', {bold: true}]},

            {lineHeight: 1.5, text: " ", style: 'normal'},
              {columns: [
                {width: 350, lineHeight: 1.5, text: {lineHeight: 1.5, text: representative ? representative : this.createUnderline(45), style: ['normal', this.processUnderline(representative)]}},
                {width: 200, lineHeight: 1.5, text: {lineHeight: 1.5, text: representativeSignature ? representativeSignature : this.createUnderline(40), style: ['normal', this.processUnderline(representativeSignature)]}},]},

              {columns: [
                {width: 350, lineHeight: 1.5, text: {text: "Authorized Live Nation Representative (Print)",
                                       style: ['normal', {bold: true}]}},
                 {width: 200, lineHeight: 1.5, text: {text: "Signature",
                                        style: ['normal', {bold: true}]}},]},
              {lineHeight: 1.5, text: " ", style: 'normal'},
              {lineHeight: 1.5, text: " ", style: 'normal'},
              {text: representativePhone ? representativePhone : this.createUnderline(40), style: ['normal', this.processUnderline(representativePhone)]},
              {lineHeight: 1.5, text: "Representative Phone Number", style: 'normalBold'},
              {lineHeight: 1.5, text: " ", style: 'normal'},
              {text: natureOfInjury ? natureOfInjury : this.createUnderline(150), style: ['normal', this.processUnderline(natureOfInjury)]},
              {lineHeight: 1.5, text: "Nature of Injury and Treatment", style: 'normalBold'},
              {lineHeight: 1.5, text: " ", style: 'normal'},
              {lineHeight: 1.5, text: "DOCTOR - Please describe nature of action IN DETAIL (e.g. what type of injury and treatment; cut/laceration, burn, bruise/fracture, faint, complaint, etc.): ", style: 'normalBold'},
              {lineHeight: 1.5, text: other_form_data.doctor_description ? other_form_data.doctor_description : this.createUnderline(400), style: 'normal'},
              {lineHeight: 1.5, text: " ", style: 'normal'},
              {text: treatmentFacility ? treatmentFacility : this.createUnderline(60), style: ['normal', this.processUnderline(treatmentFacility)]},
              {text: "Treatment Facility Name/Address/Phone",
                                     style: ['normalBold']},
             {lineHeight: 1.5, text: " ", style: 'normal'},
             {columns: [
               {width: 350, text: physician ? physician : this.createUnderline(40), style: ['normal', this.processUnderline(physician)]},
                {width: 200, text: physicianSignature ? physicianSignature : this.createUnderline(40), style: ['normal', this.processUnderline(physicianSignature)]}]},
             {columns: [
               {width: 350, lineHeight: 1.5, text: {text: "Treating Physician",
                                      style: ['normal', {bold: true}]}},
                {width: 200, lineHeight: 1.5, text: {text: "Physician's Signature",
                                       style: ['normal', {bold: true}]}},]},
            ]
    }

    renderRefusal(selectedItem, other_form_data, type) {

      if(other_form_data.first_aid !== "Declined") {
        return
      }
      var refusal_of_medical_treatment_form = other_form_data.refusal_of_medical_treatment_form;
      //console.log("refusal_of_medical_treatment_form: ", refusal_of_medical_treatment_form);

      var witnesses = refusal_of_medical_treatment_form && refusal_of_medical_treatment_form.refusal_witnesses ? refusal_of_medical_treatment_form.refusal_witnesses : this.createUnderline(80);
      var name = refusal_of_medical_treatment_form && refusal_of_medical_treatment_form.refusal_name ? refusal_of_medical_treatment_form.refusal_name : null;
      var date = selectedItem && selectedItem.date_added ? {text: moment(selectedItem.date_added).format("MMMM Do YYYY"), style: {decoration: "underline"}} : {text: this.createUnderline(15)};
      var refusal_venue = refusal_of_medical_treatment_form && refusal_of_medical_treatment_form.refusal_venue ? refusal_of_medical_treatment_form.refusal_venue : this.createUnderline(80);
      var natureOfInjury = refusal_of_medical_treatment_form && refusal_of_medical_treatment_form.refusal_condition ? refusal_of_medical_treatment_form.refusal_condition : null;
      var descriptionOfInjury = refusal_of_medical_treatment_form && refusal_of_medical_treatment_form.refusal_injury ? refusal_of_medical_treatment_form.refusal_injury : null;
      var briefDescription = refusal_of_medical_treatment_form && refusal_of_medical_treatment_form.refusal_incident_details ? refusal_of_medical_treatment_form.refusal_incident_details : null;
      var parentSignature = refusal_of_medical_treatment_form && refusal_of_medical_treatment_form.refusal_parent_signature ? refusal_of_medical_treatment_form.refusal_parent_signature : null;
      var signature = refusal_of_medical_treatment_form && refusal_of_medical_treatment_form.refusal_signature ? refusal_of_medical_treatment_form.refusal_signature : null;
      var supervisor = refusal_of_medical_treatment_form && refusal_of_medical_treatment_form.refusal_supervisor ? refusal_of_medical_treatment_form.refusal_supervisor : null;

      // name = null;
      // witnesses = null;
      // date = null;
      // refusal_venue = null;
      // natureOfInjury = null;
      // descriptionOfInjury = null;
      // briefDescription = null;


      if(type === "employee") {
        return [{pageBreak: 'before', text: "REFUSAL OF MEDICAL TREATMENT OR OBSERVATION FORM", style: ['title', {bold: true}]},
                {text: "(Employee)", style: ['title']},
                {text: " ", style: ['title']},
                {text: " ", style: ['title']},
                {lineHeight: 1.5, text: [{text: "Name: ", style: ['normal', {bold: true}]},
                                 {text: name ? name : this.createUnderline(80), style: ['normal']},
                              ]},
                {lineHeight: 1.5, text: [{text: "Work Location: ", style: ['normal', {bold: true}]},
                                 {text: refusal_venue ? refusal_venue : this.createUnderline(80), style: ['normal']},
                              ]},
                {lineHeight: 1.5, text: [{text: "Supervisor: ", style: ['normal', {bold: true}]},
                                 {text: supervisor ? supervisor : this.createUnderline(80), style: ['normal']},
                              ]},
                {lineHeight: 1.5, text: [{text: "Witness(es): ", style: ['normal', {bold: true}]},
                                 {text: witnesses ? witnesses : this.createUnderline(80), style: 'normal'},
                              ]},
                {lineHeight: 1.5, text: [{text: "Nature of Injury/Condition: ", style: ['normal', {bold: true}]},
                                          {text: natureOfInjury ? natureOfInjury : " "+this.createUnderline(245), style: 'normal'},
                              ]},
                {lineHeight: 1.5, text: [{text: "Description of Injury [Body Part(s) Injured]: ", style: ['normal', {bold: true}]},
                {text: descriptionOfInjury ? descriptionOfInjury : " "+this.createUnderline(245)
                  +" "+this.createUnderline(136), style: ['normal']},
                              ]},
                {lineHeight: 1.5, text: [{text: "Brief Narrative Description of the Incident: ", style: ['normal', {bold: true}]},
                                          {text: briefDescription ? briefDescription : this.createUnderline(245) , style: 'normal'},
                              ]},
                {lineHeight: 1.5, text: " ", style: 'normal'},
                {lineHeight: 1.5, text: [{text: " I, " }, name ? {text: name, style: {decoration: "underline"}} : this.createUnderline(30), {text: ", hereby acknowledge my refusal"
                                +" of   medical   treatment   and/or observation offered to me at the expense of Live Nation Entertainment, Inc. on behalf of itself and its parents,"
                                +" subsidiaries,  and  affiliated  companies  (collectively,  “Live  Nation”) and  pursuant  to  the  statutory  workers  compensation regulations"
                                +"  applicable to this work location, for the  work-related injury I incurred on "}, date ? date : this.createUnderline(15)+".",], style: 'normal'},
                {lineHeight: 1.5, text: " ", style: 'normal'},
                {lineHeight: 1.5, text: "By  signing  this  form, I realize that I  do  not  necessarily  affect  my  later  eligibility  for  any  workers’"
                                        +" compensation benefits directly related to the injury described above.", style: 'normal'},
                {lineHeight: 1.5, text: " ", style: 'normal'},
                {lineHeight: 1.5, text: "At a later time, I understand that I may request from my supervisor(s) a medical authorization to obtain "
                                        + " medical treatment and/or observation for the above described injury, which request may then be either "
                                        + " approved or denied for eligible workers compensation benefits.", style: 'normal'},
                {lineHeight: 1.5, text: " ", style: 'normal'},
                {lineHeight: 1.5, text: "I acknowledge that Live  Nation offered and made available to me an opportunity to seek medical treatment and/or observation, and I refused. ", style: 'normal'},

                {lineHeight: 1.5, text: " ", style: 'normal'},
                {lineHeight: 1.5, text: [{text: "Signature: ", style: ['normal', {bold: true}]},
                                 {text: signature ? signature : this.createUnderline(30), style: ['normal', this.processUnderline(signature)]},
                              ]},
                {lineHeight: 1.5, text: " ", style: 'normal'},
                {lineHeight: 1.5, text: [{text: "Date: ", style: ['normal', {bold: true}]},
                                 {text: moment().format("MMMM DD, YYYY"), style: 'normal'},]},]
      } else {
        return [{pageBreak: 'before', text: "REFUSAL OF MEDICAL TREATMENT OR OBSERVATION FORM", style: ['title', {bold: true}]},
                {text: "(Guest)", style: ['title']},
                {text: " ", style: ['title']},
                {text: " ", style: ['title']},
                {lineHeight: 1.5, text: [{text: "Name (Print): ", style: ['normal', {bold: true}]},
                                 {text: name ? name : this.createUnderline(80), style: ['normal']},
                              ]},
                {lineHeight: 1.5, text: [{text: "Witness(es): ", style: ['normal', {bold: true}]},
                                 {text: witnesses ? witnesses : this.createUnderline(80), style: 'normal'},
                              ]},
                {lineHeight: 1.5, text: [{text: "Nature of Injury/Condition: ", style: ['normal', {bold: true}]},
                                          {text: natureOfInjury ? natureOfInjury : " "+this.createUnderline(245), style: 'normal'},
                              ]},
                {lineHeight: 1.5, text: [{text: "Description of Injury [Body Part(s) Injured]: ", style: ['normal', {bold: true}]},
                {text: descriptionOfInjury ? descriptionOfInjury : " "+this.createUnderline(245)
                  +" "+this.createUnderline(136), style: ['normal']},
                              ]},
                {lineHeight: 1.5, text: [{text: "Brief Narrative Description of the Incident: ", style: ['normal', {bold: true}]},
                                          {text: briefDescription ? briefDescription : this.createUnderline(245) , style: 'normal'},
                              ]},
                {lineHeight: 1.5, text: " ", style: 'normal'},
                {lineHeight: 1.5, text: [{text: " I, " }, name ? {text: name, style: {decoration: "underline"}} : this.createUnderline(30), {text: ", hereby   acknowledge   my   refusal   of   medical   treatment   and/or observation"
                                    +" offered to me for the injury I incurred on "}, date ? date : this.createUnderline(15), {text: ", at "}, refusal_venue ? refusal_venue : this.createUnderline(15),
                                    {text: " either as provided for by employees of Live Nation Entertainment, Inc. on behalf of itself and it's parents, "
                                    +"subsidiaries, and affiliated companies (collectively, \"Live Nation\") or as provided by a service directly contracted by Live Nation."
                                    +" Additionally, I have instructed Live Nation not to dispatch ambulatory or other medical services external to and unaffiliated with Live Nation"}], style: 'normal'},
                {lineHeight: 1.5, text: " ", style: 'normal'},
                {lineHeight: 1.5, text: "By signing this document, I acknowledge that I am aware of the potential benefits of medical "
                                        +"treatment and the risks associated with refusing such treatment, which I fully understand. In spite of this"
                                        +" understanding, I refuse to consent to medical treatment.", style: 'normal'},

                {lineHeight: 1.5, text: " ", style: 'normal'},
                {lineHeight: 1.5, text: [{text: "Name: ", style: ['normal', {bold: true}]},
                                 {text: name, style: 'normal'},
                              ]},
                {lineHeight: 1.5, text: " ", style: 'normal'},
                {lineHeight: 1.5, text: [{text: "Signature: ", style: ['normal', {bold: true}]},
                                 {text: signature ? signature : this.createUnderline(30), style: ['normal', this.processUnderline(signature)]},
                              ]},
                {lineHeight: 1.5, text: " ", style: 'normal'},
                {lineHeight: 1.5, text: "Parent’s/Guardian’s Signature if individual is a minor: ", style: ['normal', {bold: true}]},
                {lineHeight: 1.5, text: " ", style: 'normal'},
                {lineHeight: 1.5, text: parentSignature ? parentSignature : this.createUnderline(50), style: 'normal'},
                {lineHeight: 1.5, text: " ", style: 'normal'},
                {lineHeight: 1.5, text: [{text: "Date: ", style: ['normal', {bold: true}]},
                                 {text: moment().format("MMMM DD, YYYY"), style: 'normal'},]},]
      }

    }

    renderGuests(selectedItem, other_form_data) {

      var individuals_data = selectedItem ? selectedItem.individuals_data
                                                ? JSON.parse(selectedItem.individuals_data)
                                                : []

                                          : [];

      var rows = [];
      //console.log("individuals_data: ", individuals_data);
      individuals_data.map((individual_data, i)=>{
        rows.push([
                       {columns: [
                                       {width: 400, text: [{text: "Guest Name: ",
                                                              style: ['normal', {bold: true}]},
                                                            {text: individual_data.name ? individual_data.name : this.createUnderline(40) , style: 'normal'},
                                                          ], lineHeight: 1.5, },
                                       {width: 150, text: [{text: "Gender: ",
                                                              style: ['normal', {bold: true}]},
                                                            {text: individual_data.gender ? individual_data.gender : this.createUnderline(10), style: ['normal']},
                                                          ], lineHeight: 1.5, }]},
                        {columns: [
                                        {width: 300, text: [{text: "Address: ",
                                                               style: ['normal', {bold: true}]},
                                                             {text: individual_data.address ? individual_data.address : this.createUnderline(50) , style: 'normal'},
                                                           ], lineHeight: 1.5, },
                                        {width: 150, text: [{text: "Phone: ",
                                                               style: ['normal', {bold: true}]},
                                                             {text: individual_data.work_phone ? individual_data.work_phone : this.createUnderline(15), style: ['normal']},
                                                           ], lineHeight: 1.5, }]},
                       {text: [{text: "How did the incident occur?  ",
                                              style: ['normal', {bold: true}]},
                                            {text: individual_data.how_incident ? individual_data.how_incident : this.createUnderline(500) , style: 'normal'},
                                          ]},

                        {lineHeight: 1.5, text: " ", style: 'normal'},
                        {text: [{text: "When did you arrive at the venue?  ",
                                               style: ['normal', {bold: true}]},
                                             {text: individual_data.arrival_time ? individual_data.arrival_time : this.createUnderline(15) , style: 'normal'},
                                           ]},

                         {columns: [
                                         {width: 200, text: [{text: "Did you eat before coming to venue?   ",
                                                                style: ['normal', {bold: true}]},
                                                              {text: individual_data.guest_eat_arrival ? "YES" : "NO" , style: 'normal'},
                                                            ], lineHeight: 1.5, },
                                         {width: 130, text: [{text: "What Foods?  ",
                                                                style: ['normal', {bold: true}]},
                                                              {text: individual_data.food_eat_prior_to_arrival ? individual_data.food_eat_prior_to_arrival : this.createUnderline(15), style: ['normal']},
                                                            ], lineHeight: 1.5, },
                                          {width: 150, text: [{text: "What Time?  ",
                                                                 style: ['normal', {bold: true}]},
                                                               {text: individual_data.time_eat_arrival ? individual_data.time_eat_arrival : this.createUnderline(10), style: ['normal']},
                                                             ], lineHeight: 1.5, }]},

                         {columns: [
                                         {width: 200, text: [{text: "Did you eat at this venue?   ",
                                                                style: ['normal', {bold: true}]},
                                                              {text: individual_data.guest_eat_venue ? "YES" : "NO" , style: 'normal'},
                                                            ], lineHeight: 1.5, },
                                         {width: 150, text: [{text: "What Foods?  ",
                                                                style: ['normal', {bold: true}]},
                                                              {text: individual_data.guest_eat_venue ? individual_data.guest_eat_venue : this.createUnderline(15), style: ['normal']},
                                                            ], lineHeight: 1.5, },
                                          {width: 150, text: [{text: "What Time?  ",
                                                                 style: ['normal', {bold: true}]},
                                                               {text: individual_data.time_eat_venue ? individual_data.time_eat_venue : this.createUnderline(10), style: ['normal']},
                                                             ], lineHeight: 1.5, }]},
                       {text: "Attach scan of final guest check to this report",
                                              style: ['normal', {bold: true, color: "red"}]},
                        {text: [{text: "Were there other similar food complaints on this date?  ",
                                               style: ['normal', {bold: true, color: "red"}]},
                                             {text: individual_data.similar_food_complaints ? "Yes" : "No" , style: ['normal', {color: "red"}]},
                                           ]},

                       {lineHeight: 1.5, text: " ", style: 'normal'},

                       // {columns: [
                       //                 {width: 200, text: [{text: "Did you consume alcohol before coming to venue?   ",
                       //                                        style: ['normal', {bold: true}]},
                       //                                      {text: individual_data.consume_alcohol ? "YES" : "NO" , style: 'normal'},
                       //                                    ], lineHeight: 1.5, },
                       //                 {width: 200, text: [{text: "What Kind?  ",
                       //                                        style: ['normal', {bold: true}]},
                       //                                      {text: individual_data.kind_of_alcohol ? individual_data.kind_of_alcohol : this.createUnderline(25), style: ['normal']},
                       //                                    ], lineHeight: 1.5, },
                       //                  {width: 150, text: [{text: "How Much?  ",
                       //                                         style: ['normal', {bold: true}]},
                       //                                       {text: individual_data.how_much_alcohol ? individual_data.how_much_alcohol : this.createUnderline(20), style: ['normal']},
                       //                                     ], lineHeight: 1.5, }]},
                         {columns: [
                                         {width: 200, text: [{text: "Did you consume alcohol at this venue?   ",
                                                                style: ['normal', {bold: true}]},
                                                              {text: individual_data.consume_alcohol ? "YES" : "NO" , style: 'normal'},
                                                            ], lineHeight: 1.5, },
                                         {width: 200, text: [{text: "What Kind?  ",
                                                                style: ['normal', {bold: true}]},
                                                              {text: individual_data.kind_of_alcohol ? individual_data.kind_of_alcohol : this.createUnderline(25), style: ['normal']},
                                                            ], lineHeight: 1.5, },
                                          {width: 150, text: [{text: "How Much?  ",
                                                                 style: ['normal', {bold: true}]},
                                                               {text: individual_data.how_much_alcohol ? individual_data.how_much_alcohol : this.createUnderline(20), style: ['normal']},
                                                             ], lineHeight: 1.5, }]},

                           {columns: [
                                           {width: 150, text: [{text: "Paid With:  ",
                                                                  style: ['normal', {bold: true}]},
                                                                {text: individual_data.paid_with ? "Cash" : "Credit" , style: 'normal'},
                                                              ], lineHeight: 1.5, },
                                           {width: 400, text: [{text: "Card Type/Name:  ",
                                                                  style: ['normal', {bold: true}]},
                                                                {text: individual_data.card_type ? individual_data.card_type : this.createUnderline(60), style: ['normal']},
                                                              ], lineHeight: 1.5, }]},
                            {text: [{text: "Guest Description of bartender/server:  ",
                                                   style: ['normal', {bold: true}]},
                                                 {text: individual_data.bartender_description ? individual_data.bartender_description : this.createUnderline(60) , style: 'normal'},
                                               ]},
                             {text: [{text: "Guest designated witnesses:  ",
                                                    style: ['normal', {bold: true}]},
                                                  {text: individual_data.guest_witness ? individual_data.guest_witness : this.createUnderline(40) , style: 'normal'},
                                                ]},

                              {columns: [
                                              {width: 150, text: [{text: "Guest have health insurance?  ",
                                                                     style: ['normal', {bold: true}]},
                                                                   {text: individual_data.health_insurance ? "YES" : "NO" , style: 'normal'},
                                                                 ], lineHeight: 1.5, },
                                              {width: 400, text: [{text: "Insurance Company:  ",
                                                                     style: ['normal', {bold: true}]},
                                                                   {text: individual_data.insurance_company ? individual_data.insurance_company : this.createUnderline(60), style: ['normal']},
                                                                 ], lineHeight: 1.5, }]},

                      {lineHeight: 1.5, text: " ", style: 'normal'},
                      {lineHeight: 1.5, text: " ", style: 'normal'},
                      {canvas: [{ type: 'line', x1: 0, y1: 5, x2: 595-2*40, y2: 5, lineWidth: 0.5 }]},
                    ])
      })
      return rows;
    }

    renderWitnesses(witnesses) {

      var type = "witness";
      var rows = [];

      witnesses.map((witness, index)=>{
        rows.push(<div key={"witness_"+index}>
                      <h3 className="div-header">Witness # {index+1}</h3>
                      <hr className="line"/>
                      {/* <div className="spacer"></div> */}

                      <FormGroup controlId="name" bsSize="sm">
                          <ControlLabel className="login_label">Witness Name</ControlLabel>
                          <FormControl
                              key={"name_"+index}
                              type="text"
                              onChange={(e)=>{
                                          this.handleChange(e, e.target.value, type, "name", index)}
                                        }
                              value={witness.name}
                          />
                      </FormGroup>

                      <FormGroup controlId="phone" bsSize="sm">
                          <ControlLabel className="login_label">Phone</ControlLabel>
                          <FormControl
                              key="phone"
                              type="text"
                              onChange={(e)=>{
                                          this.handleChange(e, e.target.value, type, "phone", index)}
                                        }
                              value={witness.phone}
                          />
                      </FormGroup>

                      <FormGroup controlId="relationship" bsSize="sm">
                          <ControlLabel className="login_label">Relationship</ControlLabel>
                          <FormControl
                              type="text"
                              key="relationship"
                              onChange={(e)=>{
                                          this.handleChange(e, e.target.value, type, "relationship", index)}
                                        }
                              value={witness.relationship}
                          />
                      </FormGroup>

                      <FormGroup controlId="address" bsSize="sm">
                          <ControlLabel className="login_label">Address</ControlLabel>
                          <FormControl
                              type="text"
                              key="address"
                              onChange={(e)=>{
                                          this.handleChange(e, e.target.value, type, "address", index)}
                                        }
                              value={witness.address}
                          />
                      </FormGroup>

                      <FormGroup controlId="description" bsSize="sm">
                          <ControlLabel className="login_label">Witness description of incident</ControlLabel>
                          <FormControl
                              key="description"
                              componentClass="textarea"
                              rows={4}
                              placeholder="Enter witness description..."
                              onChange={(e)=>{
                                          this.handleChange(e, e.target.value, type, "description", index)}
                                        }
                              value={witness.description}
                          />
                      </FormGroup>
                </div>);
      })

      return rows;

    }

    makePDFBlob(docDef, callback) {
      var pdfDocGenerator = pdfMake.createPdf(docDef);
      pdfDocGenerator.getBlob((blob)=>{
        callback(blob);
      })
    }

    createUnderline(underscoreCount) {
      //PDF width is like, 137 characters long
      var string = "";
      var index = 0;

      while(index < underscoreCount) {
        string+="_";
        index++;
      }
      return string;
    }

    processUnderline(value) {

        if(value) {
          return {decoration: "underline"}
        } else {
          return {}
        }
    }

    stringArrayToString(strings) {
      var newString = "";
      //console.log("strings: ", strings);
      try{
        if(strings != null) {
            strings.forEach((string)=>{
              if(newString === "") {
                newString = string;
              } else {
                newString+=", "+string;
              }

            })
        } else {
            newString = "None"
        }
      }
      catch(e){
          //error here;
      }

      return newString;
    }

    setDownloadPDF(downloadPDF) {
      this.setState({
        downloadPDF: downloadPDF
      })
    }

    setCountSelectedIncidents(countFunction) {
      this.setState({
        countSelectedIncidents: countFunction,
      })
    }
}

export default Incident;
